<script>
const { VUE_APP_API_HOST } = process.env

export default {
  data: function() {
    return {
      // API
      apiRoute: `${VUE_APP_API_HOST}/accounts/me/payment-method`,

      // Card information
      expMonth: null,
      expYear: null,
      last4: null,

      countryPaypal: null,
      payer_email: null,
      payer_id: null,

      typePM: null
    }
  },

  computed: {
    hasRegisteredCard: function() {
      return (this.expMonth && this.expYear && this.last4) || this.typePM
    }
  },

  created: async function() {
    // Get payment method from Stripe through engine
    await this.fetchPaymentMethod()
    // If no credit card has been given, go to edit mode
    this.editMode = !this.last4
  },

  methods: {
    async fetchPaymentMethod() {
      // Fetch payment method from server
      const {data} = await this.$http.get(this.apiRoute, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch(err => console.error(err))

      if(data.last4 && data.exp_month && data.exp_year)
        this.readCard(data)
      else if(data.last4) { //sepa
        this.last4 = data.last4
        this.typePM = 'sepa'
      }
      else if(data.type == 'paypal') { //paypal
        this.countryPaypal = data.country
        this.payer_email = data.payer_email
        this.payer_id = data.payer_id
        this.typePM = 'paypal'
      }
      else {
        this.typePM = null
        this.expMonth = null,
        this.expYear = null,
        this.last4 = null,
        this.countryPaypal = null,
        this.payer_email = null,
        this.payer_id = null
      }

    },

    readCard(card) {
      // Expiry month/year
      this.expMonth = String(card.exp_month).padStart(2, '0')
      this.expYear  = String(card.exp_year % 100).padStart(2, '0')
      // Last four digits in credit card number
      this.last4    = card.last4
      this.typePM = 'card'
    },
  }
}
</script>
